var exports = {
  "iE": "x28a7bf27--fd97fa--wrapper",
  "kL": "x28a7bf27--fd97fa--container",
  "Qs": "x28a7bf27--fd97fa--content",
  "wm": "x28a7bf27--fd97fa--logo",
  "Qq": "x28a7bf27--fd97fa--text",
  "Zd": "x28a7bf27--fd97fa--form",
};

module.exports = exports;
